import { render, staticRenderFns } from "./DataInputVariableRelation.vue?vue&type=template&id=1786dd20&"
import script from "./DataInputVariableRelation.vue?vue&type=script&lang=js&"
export * from "./DataInputVariableRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports